import { createFileRoute } from "@tanstack/react-router";
import { MaaledataValidatePage } from "@/features/maaledata/validering/MaaledataValidatePage";

export const Route = createFileRoute("/_public/_landing/validering")({
  component: MaaledataValidatePage,
  head: () => ({
    meta: [
      {
        title: "Testområde | Selskapsportal for fjernvarme",
      },
    ],
  }),
});
